"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _reactIntl = require("react-intl");

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _AssetEmptyState = _interopRequireDefault(require("./AssetEmptyState.scss"));

var _svgs = require("../../lib/svgs");

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var uiStrings = {
  cloudDoc: {
    title: 'comments.asset-empty-state.cloud-doc.save-title',
    subtitle: 'comments.asset-empty-state.cloud-doc.save-subtitle',
    shareButton: 'comments.asset-empty-state.cloud-doc.save'
  },
  artifact: {
    title: 'comments.asset-empty-state.artifact.share-title',
    subtitle: 'comments.asset-empty-state.artifact.share-subtitle',
    shareButton: 'comments.asset-empty-state.artifact.share'
  }
};
/**
 * Displays message that CommentsEmptyState with a CTA to share.
 * @param {Object} props - props for component
 * @returns {undefined}
 */

var AssetEmptyState = function AssetEmptyState(_ref) {
  var onShare = _ref.onShare,
      reviewType = _ref.reviewType;
  var strings = uiStrings[reviewType];
  var ccxIngest = (0, _useIngest.default)();
  var illustration = reviewType === 'cloudDoc' ? _svgs.UnsavedIllustration : _svgs.ShareIllustration;
  var shareButtonVariant = reviewType === 'cloudDoc' ? 'primary' : 'cta';
  var emptyStateTestId = reviewType === 'cloudDoc' ? 'empty-state-cloud' : 'empty-state-artifact';
  (0, _react.useEffect)(function () {
    ccxIngest.fireEvent(ccxIngest.events.noAsset); // disabling exhaustive-deps because ccxIngest should never change and if it does,
    // we dont want this to fire more than on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onShareClick = (0, _react.useCallback)(function () {
    onShare();
  }, [onShare]);
  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, {
    testId: emptyStateTestId
  }, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, illustration), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: strings.title
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Subtitle, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: strings.subtitle
  })), onShare && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _AssetEmptyState.default.commentsShareForReviewBtn,
    "data-testid": "empty-state-cta",
    variant: shareButtonVariant,
    onClick: onShareClick
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: strings.shareButton
  })));
};

AssetEmptyState.defaultProps = {
  onShare: undefined,
  reviewType: 'artifact'
};
AssetEmptyState.propTypes = {
  onShare: _propTypes.default.func,
  reviewType: _propTypes.default.oneOf(['artifact', 'cloudDoc'])
};
var _default = AssetEmptyState;
exports.default = _default;